import React from "react"
import { useContext } from "react"
import { Button } from "../../../../components/Button"
import { ConfirmationDialog } from "../../../../components/Dialog"
import { NotesContext } from "../../context"

export const Destroy = () => {
  const { state, actions } = useContext(NotesContext)
  const { note, loading } = state
  const { deleteNote, back } = actions

  return (
    <ConfirmationDialog
      heading={'Are you sure you want to delete this note?'}
      subheading={""}
      primaryButton={() =>
        <Button
          primary trackAs={'Deleting scenario note'}
          disabled={loading} onClick={deleteNote}
        >
          {loading ? 'Removing note...' : `YES I'M SURE`}
        </Button>
      }
      secondaryButton={() => <Button disabled={loading} secondary onClick={back}>{`NOT RIGHT NOW`}</Button>} />
  )
}